import definitions from './dashboardsDefinitions';

export const generateFromKeys = keys => {
  if (!keys) return [];
  return keys
    .filter(key => typeof definitions[key] !== 'undefined')
    .map(key => ({
      ...definitions[key],
      i: key,
    }));
};

export const getEnabledDashboards = () =>
  Object.keys(definitions).filter(key => {
    if (!definitions[key]) return false;
    const { enabled } = definitions[key];
    if (typeof enabled === 'undefined') return true; // No enabled property= enabled
    if (typeof enabled === 'boolean') return enabled; // Just return boolean
    if (typeof enabled === 'function') return !!enabled(); // Call function
    return !!enabled; // Unknown type, convert to bool
  });
export const getEnabledDashboardDefinitions = () => generateFromKeys(getEnabledDashboards());

export const breakpoints = { lg: 1200, md: 992, sm: 768, xs: 0 };
export const breakpointCols = { lg: 12, md: 6, sm: 4, xs: 2 };

export const defaultLayouts = {
  lg: [
    { i: 'SearchRelation', x: 0, y: 0, w: 2, h: 0.5 },
    { i: 'RecentRelations', x: 0, y: 1, w: 2, h: 6.5 },
    { i: 'RevenuePerMonth', x: 2, y: 0, w: 5, h: 4 },
    { i: 'MostValuableCustomers', x: 7, y: 0, w: 5, h: 4 },
    { i: 'Compliancy', x: 2, y: 1, w: 5, h: 3 },
    { i: 'MyTasksKpis', x: 7, y: 1, w: 5, h: 3 },
    { i: 'MyTodos', x: 7, y: 2, w: 5, h: 6 },
    { i: 'MyRegistrations', x: 2, y: 2, w: 5, h: 4 },
    { i: 'Absences', x: 2, y: 3, w: 5, h: 3 },
    { i: 'PeppolOnboarding', x: 2, y: 4, w: 5, h: 3 },
  ],
  md: [
    { i: 'SearchRelation', x: 0, y: 0, w: 6, h: 0.5 },
    { i: 'RecentRelations', x: 0, y: 1, w: 3, h: 4 },
    { i: 'RevenuePerMonth', x: 3, y: 1, w: 3, h: 4 },
    { i: 'Compliancy', x: 0, y: 2, w: 3, h: 4 },
    { i: 'MostValuableCustomers', x: 3, y: 2, w: 3, h: 4 },
    { i: 'MyTasksKpis', x: 0, y: 3, w: 3, h: 3 },
    { i: 'MyRegistrations', x: 0, y: 4, w: 3, h: 4 },
    { i: 'MyTodos', x: 3, y: 3, w: 3, h: 7 },
    { i: 'Absences', x: 0, y: 5, w: 3, h: 3 },
    { i: 'PeppolOnboarding', x: 0, y: 6, w: 3, h: 3 },
  ],
  sm: [
    { i: 'SearchRelation', x: 0, y: 0, w: 4, h: 0.5 },
    { i: 'RecentRelations', x: 0, y: 1, w: 1, h: 6 },
    { i: 'RevenuePerMonth', x: 1, y: 1, w: 3, h: 3 },
    { i: 'MostValuableCustomers', x: 1, y: 2, w: 3, h: 3 },
    { i: 'MyTasksKpis', x: 0, y: 3, w: 2, h: 3 },
    { i: 'Compliancy', x: 2, y: 3, w: 2, h: 2 },
    { i: 'MyRegistrations', x: 0, y: 4, w: 2, h: 3 },
    { i: 'MyTodos', x: 3, y: 4, w: 2, h: 4 },
    { i: 'Absences', x: 0, y: 5, w: 2, h: 2 },
    { i: 'PeppolOnboarding', x: 0, y: 6, w: 2, h: 2 },
  ],
  xs: [
    { i: 'SearchRelation', x: 0, y: 0, w: 2, h: 0.25 },
    { i: 'RecentRelations', x: 0, y: 1, w: 2, h: 2 },
    { i: 'RevenuePerMonth', x: 0, y: 2, w: 2, h: 2 },
    { i: 'MostValuableCustomers', x: 0, y: 3, w: 2, h: 2 },
    { i: 'Compliancy', x: 0, y: 4, w: 2, h: 2 },
    { i: 'MyTasksKpis', x: 0, y: 5, w: 2, h: 1 },
    { i: 'MyTodos', x: 0, y: 6, w: 2, h: 3 },
    { i: 'MyRegistrations', x: 0, y: 7, w: 2, h: 2 },
    { i: 'Absences', x: 0, y: 8, w: 2, h: 2 },
    { i: 'PeppolOnboarding', x: 0, y: 9, w: 2, h: 2 },
  ],
};
const valueInRange = (value, min, max) => value >= min && value <= max;

const rectOverlap = (A, B) => {
  const xOverlap = valueInRange(A.x, B.x, B.x + B.w - 1) || valueInRange(B.x, A.x, A.x + A.w - 1);

  const yOverlap = valueInRange(A.y, B.y, B.y + B.h - 1) || valueInRange(B.y, A.y, A.y + A.h - 1);

  return xOverlap && yOverlap;
};

export const findOpenPosition = (layout, breakpoint, w = 1, h = 1) => {
  const maxCols = breakpointCols[breakpoint] || 12;
  // Max 100 rows should be enough
  for (let y = 0; y < 100; y += 1) {
    for (let x = 0; x <= maxCols - w; x += 1) {
      const tmp = { x, y, w, h };
      const overlapping = layout.find(item => rectOverlap(item, tmp));
      if (!overlapping) return { x, y };
    }
  }
  // Normally this should not be reached, but fallback to be sure
  return { x: 0, y: 999 };
};

export const removeItemFromLayouts = (layouts, item) => {
  const newLayouts = { ...layouts };
  Object.keys(newLayouts).forEach(breakpoint => {
    newLayouts[breakpoint] = newLayouts[breakpoint].filter(x => x.i !== item.i);
  });
  return newLayouts;
};
export const addItemToLayouts = (layouts, item) => {
  const newLayouts = { ...layouts };
  Object.keys(newLayouts).forEach(breakpoint => {
    const defaultLayout = defaultLayouts[breakpoint] || [];
    const dl = defaultLayout.find(x => x.i === item.i) || {};
    const size = {
      w: item.w || dl.w || 1,
      h: item.h || dl.h || 1,
    };
    const { x = -1, y = -1 } = { ...item, ...dl };
    const position =
      item.static && (x >= 0 || y >= 0) // Fixed position, not movable
        ? { x, y }
        : findOpenPosition(newLayouts[breakpoint], breakpoint, size.w, size.h); // Otherwise find open position

    newLayouts[breakpoint] = [
      ...newLayouts[breakpoint],
      {
        ...item,
        ...size,
        ...position,
      },
    ];
  });
  return newLayouts;
};

export const validateLayouts = (layouts, dashboards) => {
  const newLayouts = { ...layouts };
  Object.keys(newLayouts).forEach(breakpoint => {
    newLayouts[breakpoint] = newLayouts[breakpoint].filter(x => dashboards.some(d => d.i === x.i));
  });
  return newLayouts;
};
